const backend = () => {
	let link;

	//local
	// link = "http://localhost:62209/";

	//Online
	link = "https://inspeuberababack.directy.com.br/"

	//produção
	// link = ""

	return link;
};

export default backend();
